var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.4C1 4.23305 1.46357 3.11389 2.28873 2.28873C3.11389 1.46357 4.23305 1 5.4 1H18.6C19.767 1 20.8861 1.46357 21.7113 2.28873C22.5364 3.11389 23 4.23305 23 5.4V18.6C23 19.767 22.5364 20.8861 21.7113 21.7113C20.8861 22.5364 19.767 23 18.6 23H5.4C4.23305 23 3.11389 22.5364 2.28873 21.7113C1.46357 20.8861 1 19.767 1 18.6V5.4Z",
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15039 10.9004C9.66917 10.9004 10.9004 9.66917 10.9004 8.15039C10.9004 6.63161 9.66917 5.40039 8.15039 5.40039C6.63161 5.40039 5.40039 6.63161 5.40039 8.15039C5.40039 9.66917 6.63161 10.9004 8.15039 10.9004Z",
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.779 12.6833L5.40039 23.0002H18.7467C19.8748 23.0002 20.9568 22.5521 21.7545 21.7543C22.5522 20.9566 23.0004 19.8747 23.0004 18.7465V18.6002C23.0004 18.0876 22.8079 17.8907 22.4614 17.5112L18.0284 12.6767C17.8218 12.4514 17.5705 12.2715 17.2905 12.1487C17.0105 12.0259 16.708 11.9628 16.4022 11.9634C16.0965 11.964 15.7942 12.0283 15.5147 12.1523C15.2353 12.2763 14.9847 12.4571 14.779 12.6833V12.6833Z",
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/imageIcon.356c9e0a477782d7405cc096b8dcb815.svg";
export { ForwardRef as ReactComponent };